import React, { useState, useContext } from "react";
import Logout from "./Logout.js";
import { MenuItems } from "./MenuItems.js";
import SilverlineLogo from "../Assets/SilverLine_Logo.png";
import { UserContext } from "../Context/UserContext.js";
import { ROLES } from "../Constants/Strings.js";
import { HOME } from "../routes.js";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useContext(UserContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-primary py-4 flex justify-between shadow-lg">
      <div className="container relative flex flex-nowrap justify-between items-center gap-2 mx-auto px-4">
        <a href={HOME} className="flex items-center min-w-0">
          <img src={SilverlineLogo} alt="SilverLine Logo" className="h-5 w-5" />

          <span className="text-xl font-semibold text-white ml-2 truncate whitespace-nowrap">
            SilverLine Ops
          </span>
        </a>

        {user.role === ROLES.ADMIN ? (
          <div className="flex items-center justify-center gap-1 bg-white text-primary px-3 py-1 rounded-full shadow text-sm whitespace-nowrap md:hidden">
            Hi{" "}
            {user.role.charAt(0).toUpperCase() +
              user.role.slice(1).toLowerCase()}
            !
          </div>
        ) : (
          <div className="flex items-center justify-center gap-1 bg-white text-primary px-3 py-1 rounded-full shadow text-sm whitespace-nowrap md:hidden">
            Hi User !
          </div>
        )}

        <button
          onClick={toggleMenu}
          type="button"
          className="bg-white inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden ring-2 ring-gray-200 shadow-sm"
          aria-controls="mobile-menu"
          aria-expanded={isMenuOpen}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        {/* Mobile backdrop */}
        {isMenuOpen && (
          <div
            className="fixed inset-0 z-30 md:hidden bg-black bg-opacity-50"
            onClick={() => setIsMenuOpen(false)}
          />
        )}

        {/* Menu Items */}
        <div
          className={`absolute md:static top-16 right-0 w-3/4 md:w-auto md:bg-primary bg-white text-white
            transition-all duration-300 ease-in-out overflow-hidden shadow-xl md:shadow-none z-50
            ${
              isMenuOpen
                ? "block opacity-100"
                : "hidden opacity-0 md:opacity-100"
            }
            md:flex md:items-center md:ml-auto`}
        >
          <ul className="flex flex-col md:flex-row md:items-center md:space-x-6 p-4 md:p-0 font-medium">
            {user.role &&
              MenuItems[user.role]?.map((item, idx) => (
                <li key={idx}>
                  <a
                    href={item.route}
                    className="block py-2 px-4 text-primary bg-white md:text-white md:bg-transparent border-b border-gray-100 md:border-0 md:hover:text-gray-600 md:p-0 rounded-md"
                  >
                    {item.name}
                  </a>
                </li>
              ))}

            <li className="hidden md:flex items-center gap-1 bg-white text-primary px-4 py-1 rounded-full shadow text-sm">
              {user.role === ROLES.ADMIN ? (
                <div>
                  Hi{" "}
                  {user.role.charAt(0).toUpperCase() +
                    user.role.slice(1).toLowerCase()}{" "}
                  !
                </div>
              ) : (
                <div>Hi User !</div>
              )}
            </li>

            <li className="md:hidden py-2 pr-4 pl-3 text-gray-700 hover:bg-gray-50">
              <Logout isMenuOpen={isMenuOpen} />
            </li>
            <li className="hidden md:block">
              <Logout isMenuOpen={false} />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
